import type { ReactNode } from 'react'

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'

import clsx from 'clsx'

import type { Variation } from '../alert'
import Alert from '../alert'
import Icon from '../icon'

type CustomAlertProps = {
  children: ReactNode
  className?: string
  variation?: Variation
  dismissible?: boolean
  icon?: IconDefinition
  iconClassName?: string
}

const CustomAlert = ({
  children,
  className,
  variation,
  dismissible,
  icon,
  iconClassName
}: CustomAlertProps) => {
  const iconClass = clsx('_mr-4', iconClassName)

  return (
    <Alert className={className} variation={variation} dismissible={dismissible}>
      <div className='_d-flex _align-items-center'>
        {icon && <Icon className={iconClass} icon={icon} data-test='custom-alert-icon' />}
        {children}
      </div>
    </Alert>
  )
}

export default CustomAlert
